export default {"src":"/_next/static/media/bungalow-icon.7025867d.svg","height":75,"width":122,"blurWidth":0,"blurHeight":0};